/**
 * Talk time as a fact — whole minutes and the seconds after them (owner decision 2026-10-09).
 *
 * Talk time is always minutes AND seconds on screen: "0 min 52 s", "12 min 05 s", "1,020 min 34 s". This is the fact
 * half of the portal's `talkTimeText` (`apps/web-app/src/talk-time.ts`): the parts, never the words. The portal and the
 * app each word the parts with their own catalog phrase, the minutes through `groupedCount` and the seconds padded by
 * {@link talkTimeSecondText}.
 *
 * A fraction of a second is dropped, never rounded up — the screen never shows a second that was not talked — and a
 * negative amount reads as zero. A value that is not a finite number of seconds raises rather than printing a
 * made-up figure.
 */
const SECOND_PER_MINUTE = 60;
/** `52` → `{ minute: 0, second: 52 }`; `725` → `{ minute: 12, second: 5 }`; `61234` → `{ minute: 1020, second: 34 }`. */
export function talkTimePartsOf(totalSecond) {
    if (!Number.isFinite(totalSecond)) {
        throw new Error(`Talk time must be a finite number of seconds, got ${String(totalSecond)}.`);
    }
    const whole = Math.max(0, Math.floor(totalSecond));
    return { minute: Math.floor(whole / SECOND_PER_MINUTE), second: whole % SECOND_PER_MINUTE };
}
/** The seconds always two digits (`00`–`59`), so a column of figures lines up. */
export function talkTimeSecondText(second) {
    return String(second).padStart(2, "0");
}
//# sourceMappingURL=talk-time.js.map